import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetServiceById = (id: string) =>
  useQuery({
    queryKey: ["get_service_by_id", id],
    queryFn: async () => {
      const res = await apiClient.get(ENDPOINTS.SERVICES.GET_SERVICE_BY_ID(id));
      return res.data;
    },
    enabled: !!id,
  });